export const users_table_lable_all = [
  "学号",
  "中文姓名",
  "英文姓名",
  "入学年份",
  "深造状态",
  "工作状态",
  "邮箱是否激活",
  "帐号是否激活",
  "专业",
  "学部",
  "出生年份",
  "性别",
  "国家地区",
  "身份证号",
  "招生类型",
  "荣誉分类",
  "毕业年份",
  "联系电话",
  "校友邮箱",
  "常用邮箱",
  "微信",
  "籍贯-省份",
  "籍贯-城市",
  "生源地",
  "生源高中",
  "标签",
  "校友类别",
  "校友福利",
  "是否本硕连读",
  "会员类别",
  "校友状态",
  "工作所在地",
  "工作单位名称",
  "工作单位性质",
  "工作行业类型",
  "工作职位",
  "工作薪酬范围",
  "工作公司注册地",
  "工作雇员人数",
  "工作年营业额",
  "工作从事何种自由职业",
  "深造所在地",
  "深造院校名称",
  "深造院校专业",
  "深造毕业年份",
  "深造其他"
];
export const users_table_lable = [
  "学号",
  "中文姓名",
  "英文姓名",
  "入学年份",
  "深造状态",
  "工作状态",
  "邮箱是否激活",
  "帐号是否激活",
  "专业",
  "学部",
  "校友类别",
  "是否本硕连读",
  "会员类别"
];
export const educations_table_lable = [
  "学号",
  "中文姓名",
  "英文姓名",
  "专业",
  "状态",
  "所在地",
  "院校名称",
  "院校专业",
  "毕业年份",
  "联系电话",
  "微信",
  "生源地",
  "是否本硕连读",
  "校友类别",
  "其他"
];
export const jobs_table_lable_base = [
  "学号",
  "中文姓名",
  "英文姓名",
  "专业",
  "入学年份",
  "状态",
  "所在地",
  "单位名称",
  "单位性质",
  "行业类型",
  "工作职位",
  "薪酬范围",
  "公司注册地",
  "雇员人数",
  "年营业额",
  "从事何种自由职业",
  "联系电话",
  "微信",
  "生源地",
  "校友类别",
  "是否本硕连读"
];
export const journals_table_lable_base = [
  "学号",
  "中文姓名",
  "英文姓名",
  "专业",
  "捐助ID",
  "捐助时间",
  "与学校关系",
  "入校时间",
  "捐助内容",
  "票据",
  "证书",
  "捐助金额",
  "捐助类型",
  "备注",
  "校友类别",
  "是否本硕连读"
];
export const honors_table_lable_base = [
  "学号",
  "中文姓名",
  "英文姓名",
  "专业",
  "荣誉ID",
  "荣誉时间",
  "荣誉内容",
  "校友类别",
  "是否本硕连读"
];

export const edu_status_options = [
  "硕士研究生",
  "博士研究生",
  "重读本科",
  "第二学士学位",
  "其他"
];
export const edu_status_filters = [
  { text: "硕士研究生", value: "硕士研究生" },
  { text: "博士研究生", value: "博士研究生" },
  { text: "重读本科", value: "重读本科" },
  { text: "第二学士学位", value: "第二学士学位" },
  { text: "其他", value: "其他" }
];
export const work_status_filters = [
  { text: "就业", value: "就业" },
  { text: "自主创业", value: "自主创业" },
  { text: "自由职业", value: "自由职业" },
  { text: "待业", value: "待业" },
  { text: "深造", value: "深造" }
];
export const activate_filters = [
  { text: "是", value: "是" },
  { text: "否", value: "否" }
];
export const gender_filters = [
  { text: "男", value: "M" },
  { text: "女", value: "F" }
];
export const region_filters = [
  { text: "男", value: "M" },
  { text: "女", value: "F" }
];
export const details_types_filters = [
  { cn: "推文链接", en: "details" },
  { cn: "文本编辑器", en: "rich_text" }
];
export const work_status_options = [
  "就业",
  "自主创业",
  "自由职业",
  "待业",
  "深造"
];
export const gender_options = ["男", "女"];
export const num_2_options = ["是", "否"];
export const relation_options = [
  "曾在学校学习",
  "曾在学校工作",
  "在职职工",
  "在校学生",
  "学校之友"
];
export const journal_type_options = ["捐赠-小程序", "捐赠", "赞助"];
export const admin_status_options = [
  {
    value: "Y",
    label: "已启用"
  },
  {
    value: "N",
    label: "已禁用"
  }
];
export const options_status = [
  { cn: "显示", en: "Y" },
  { cn: "隐藏", en: "N" }
];
export const options_type = [
  { cn: "链接", en: "link" },
  { cn: "资讯", en: "news" },
  { cn: "活动", en: "activity" }
];
export const options_yesorno = [{ cn: "是", en: "Y" }, { cn: "否", en: "N" }];
export const options_push = [
  { cn: "已推送", en: "Y" },
  { cn: "未推送", en: "N" }
];
export const options_release = [
  { text: "已发布", value: "Y" },
  { text: "未发布", value: "N" }
];
export const options_examine = [
  { text: "等待", value: "0" },
  { text: "通过", value: "1" },
  { text: "拒绝", value: "3" }
];
export const options_register_examine = [
  { text: "等待", value: "0" },
  { text: "通过", value: "1" },
  { text: "拒绝", value: "3" },
  { text: "待缴费", value: "5" }
];
export const options_examine_1 = [
  { text: "启用", value: "Y" },
  { text: "禁用", value: "N" }
];
export const options_attestation = [
  { text: "认证成功", value: "1" },
  { text: "已识别 未填写资料", value: "2" },
  { text: "未知校友", value: "3" }
];
export const options_activation = [
  { text: "已激活", value: "Y" },
  { text: "等待重新激活", value: "N" }
];
export const options_member_type = [
  { text: "当然会员", value: "ex_officio_member" },
  { text: "注册会员", value: "registered_member" },
  { text: "荣誉会员", value: "honorary_member" },
];
export const options_face_member_type = [
  { text: "当然会员", value: "ex_officio_member" },
  { text: "荣誉会员", value: "honorary_member" },
];
export const options_open = [
  { text: "启用", value: "Y" },
  { text: "未启用", value: "N" }
];
export const options_state_product = [
  { text: "售卖中", value: "SALE" },
  { text: "暂停售卖", value: "BAN" }
];
export const options_state_integral_order = [
  { text: "待支付", value: "NOTPAY" },
  { text: "待发货", value: "WAITDELIVERED" },
  { text: "已发货", value: "WAITGOODS" },
  // { text: '待评价', value: 'WAITEVALUATION' },
  // { text: '订单完成', value: 'SUCCESS' },
  // { text: '退款/售后', value: 'AFTERSALES' },
  { text: "交易关闭", value: "CLOSED" }
];
export const options_state_examine = [
  { text: "未审核", value: "NULL" },
  { text: "同意", value: "PASS" },
  { text: "拒绝", value: "FAIL" }
];
export const country_options = [
  "中国（含港澳台地区）",
  "英国",
  "美国",
  "澳洲",
  "加拿大",
  "日本",
  "韩国",
  "其他"
];
export const unit_options = [
  "国有企业",
  "国有控股企业",
  "外资企业",
  "合资企业",
  "私营企业（民营企业）",
  "国家行政机关",
  "事业单位",
  "社会组织机构"
];
export const job_type_options = [
  "农、林、牧、渔业",
  "采矿业",
  "制造业",
  "电力、热力、燃气及水生产和供应业",
  "建筑业",
  "批发和零售业",
  "交通运输、仓储和邮政业",
  "住宿和餐饮业",
  "信息传输、软件和技术服务业",
  "金融业",
  "房地产业",
  "租赁和商务服务业",
  "科学研究和技术服务业",
  "水利、环境和公共设施管理业",
  "居民服务、修理和其他服务业",
  "教育",
  "卫生和社会工作",
  "文化、体育和娱乐业",
  "公共管理、社会保障和社会组织",
  "国际组织",
  "其他"
];
export const pay_options = [
  "3000-5000",
  "5001-7000",
  "7001-10000",
  "10001-15000",
  "15001-20000",
  "20001-30000",
  "30001-50000",
  "50000以上"
];
export const turnover_options = [
  "30万以下",
  "30-100万",
  "100-300万",
  "300-500万",
  "500-1000万",
  "1000万以上"
];
export const employees_options = [
  "5人以下",
  "6-10人",
  "11-50人",
  "51-100人",
  "100人以上"
];
export const programme_options = [
  "Applied Economics",
  "Finance",
  "Accounting",
  "Management of Human Resources",
  "Marketing Management",
  "e-Business Management and Information Systems",
  "Entrepreneurship and Innovation",
  "Culture, Creativity and Management",
  "Cultural Industries Management",
  "Cinema and Television",
  "Media Arts and Design",
  "Computer Science and Technology",
  "Environmental Science",
  "Statistics",
  "Food Science and Technology",
  "Applied Psychology",
  "Financial Mathematics",
  "Data Science",
  "Government and International Relations",
  "International Journalism",
  "Public Relations and Advertising",
  "Social Work and Social Administration",
  "Teaching English as a Second Language",
  "Applied Translation Studies",
  "Contemporary English Language and Literature",
  "其他"
];
export const membership_category_options = [
  {
    value: "ex_officio_member",
    label: "当然会员"
  },
  {
    value: "registered_member",
    label: "注册会员"
  },
  {
    value: "honorary_member",
    label: "荣誉会员"
  }
];
export const journal_bill_certificate_options = [
  {
    value: "NO",
    label: "未申请"
  },
  {
    value: "APPLY",
    label: "已申请"
  },
  {
    value: "MAIL",
    label: "已寄送"
  }
];
export const formar_gender = {
  M: "男",
  F: "女"
};
export const formar_member_type = {
  "ex_officio_member": "当然会员",
  "registered_member": "注册会员",
  "honorary_member": "荣誉会员",
};



// WEBPACK FOOTER //
// ./src/utils/constant.js